import { createReducer } from 'typesafe-actions'

import { ReadUserReferralsRequestDto, ReadUserReferralsResponseDto } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import {
  requestIntroducerRequest,
  requestIntroducerSuccess,
  requestIntroducerFailure,
  requestIntroducerCanUpdateUserDetails,
  getReferralsRequest,
  getReferralsSuccess,
  getReferralsFailure,
} from '../actions'
import { LoadingState } from '../../types'

const initialMetaState = {
  currentPage: 0,
  itemCount: 0,
  itemsPerPage: 0,
  totalItems: 0,
  totalPages: 0,
}

export type IntroducerState = {
  canUpdateUserDetails: boolean
  status: LoadingState
  error: Error | null
  referredUsers: {
    filters: Partial<ReadUserReferralsRequestDto>
    status: LoadingState
    data: ReadUserReferralsResponseDto
    error: Error | null
  }
}

export const initialState: IntroducerState = {
  canUpdateUserDetails: false,
  status: 'IDLE',
  error: null,
  referredUsers: {
    status: 'IDLE',
    filters: {},
    data: {
      items: [],
      meta: initialMetaState,
    },
    error: null,
  },
}

export const introducer = createReducer<IntroducerState, ActionTypes>(initialState)
  .handleAction(requestIntroducerRequest, (state) => ({ ...state, status: 'LOADING' }))
  .handleAction(requestIntroducerSuccess, (state, { payload }) => ({
    ...state,
    status: 'SUCCESS',
    canUpdateUserDetails: payload.success,
  }))
  .handleAction(requestIntroducerFailure, (state, { payload }) => ({ ...state, status: 'ERROR', error: payload }))
  .handleAction(requestIntroducerCanUpdateUserDetails, (state, { payload }) => ({
    ...state,
    canUpdateUserDetails: payload,
  }))
  .handleAction(getReferralsRequest, (state, { payload }) => ({
    ...state,
    referredUsers: {
      ...state.referredUsers,
      status: 'LOADING',
      filters: {
        ...state.referredUsers.filters,
        ...payload,
      },
    },
  }))
  .handleAction(getReferralsSuccess, (state, { payload }) => ({
    ...state,
    referredUsers: {
      ...state.referredUsers,
      status: 'SUCCESS',
      data: payload,
    },
  }))
  .handleAction(getReferralsFailure, (state, { payload }) => ({
    ...state,
    referredUsers: {
      ...state.referredUsers,
      status: 'ERROR',
      data: initialState.referredUsers.data,
      error: payload,
    },
  }))
